import type { EChartsOption } from 'echarts'
import type { ParsedTable, ChartGeneratorSettings, ChartType } from '../types'

// Import all generator functions
import { lineOptions } from './line'
import { barOptions } from './bar'
import { columnOptions } from './column'
import { pieOptions } from './pie'
import { stackedBarOptions } from './stackedBar'
import { clusteredBarOptions } from './clusteredBar'
import { stackedColumnOptions } from './stackedColumn'
import { clusteredColumnOptions } from './clusteredColumn'
import { scatterOptions } from './scatter'

/**
 * Type definition for a chart generator function
 */
export type ChartGeneratorFunction = (
  table: ParsedTable,
  title: string,
  settings?: ChartGeneratorSettings
) => EChartsOption | null;

/**
 * Registry mapping ChartType identifiers to their corresponding ECharts option generator functions
 */
export const generators: Record<ChartType, ChartGeneratorFunction> = {
  table: () => null, // Table view is handled directly by the component
  pie: pieOptions,
  bar: barOptions,
  column: columnOptions,
  line: lineOptions,
  stackedBar: stackedBarOptions,
  clusteredBar: clusteredBarOptions,
  stackedColumn: stackedColumnOptions,
  clusteredColumn: clusteredColumnOptions,
  scatter: scatterOptions,
}
